define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/ClientUtil',
	'amdi18n-loader?!identity/nls/IdentityEncryptView_strings',
	'lib/jquery',
	'lib/bootstrap/tooltip' // doesn't export
], function (
	Util,
	UiUtil,
	ClientUtil,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * BindingView class
	 */
	return function (encryptCallbacks, input_callback) {
		var _view,
			_minSecretLength = 4;

		_view = (function () {
			var $identityEncryptView = jQuery(
					"<div id='skIdS_identity-encrypt-container'>" +
						"<div style='width: 80%;'>" +
							"<div>" +
								"<div style='width: 100%;'>" +
									"<p>" + Strings.insert_pin_text + ":</p>" +
									"<input id='skIdS_identity-encrypt-first-input' type='password' maxlength='100' tabindex='1' autofocus='autofocus'/>" +
									"<p>" + Strings.repeat_pin_text + ":</p>" +
									"<input id='skIdS_identity-encrypt-repeat-input' type='password' maxlength='100' tabindex='2'/>" +
									"<span id='skIdS_identity-encrypt-fido-input-container'><label for='skIdS_identity-encrypt-fido-input'>"+
									Strings.additional_fido+
									"</label><input id='skIdS_identity-encrypt-fido-input' type='checkbox' value='FIDO'></span>" +
									"<div id='skIdS_identity-encrypt-fido-container'>" +
									"</div>"+
								"</div>" +
							"</div>" +
							"<span id='skIdS_identity-encrypt-input-error'><span>" +
						"</div>" +
					"</div>");
			if (ClientUtil.isMobileClient()) {
			    $identityEncryptView.find('#skIdS_identity-encrypt-fido-container')
				.empty().append(Strings.activate_fido_mobile);
			} else {
			    $identityEncryptView.find('#skIdS_identity-encrypt-fido-container')
				.empty().append(Strings.activate_fido);
			}

			function handleInput() {
				var secret = $identityEncryptView.find('#skIdS_identity-encrypt-first-input').val(),
					secretRepeat = $identityEncryptView.find('#skIdS_identity-encrypt-repeat-input').val();

				if (secret.length >= _minSecretLength && secretRepeat.length >= _minSecretLength) {
					$identityEncryptView.find('#skIdS_identity-encrypt-button')
						.tooltip('hide')
						.tooltip('disable');
				} else {
					$identityEncryptView.find('#skIdS_identity-encrypt-button').tooltip('enable');
				}

				$identityEncryptView.find('#skIdS_identity-encrypt-input-error').hide();
			}

			function checkFields() {
				var $secretInput = $identityEncryptView.find('#skIdS_identity-encrypt-first-input'),
					$secretRepeatInput = $identityEncryptView.find('#skIdS_identity-encrypt-repeat-input'),
					$inputError = _view.find('#skIdS_identity-encrypt-input-error');

				if ($secretInput.val() !== $secretRepeatInput.val()) {
					$inputError.empty()
						.append(Strings.error_match_text)
						.show();

					$secretInput.val('');
					$secretRepeatInput.val('');

					return false;
				}

				return true;
			}

			function handleKeyPress(event) {
				var code = event.keyCode || event.which,
					$secretInput = $identityEncryptView.find('#skIdS_identity-encrypt-first-input'),
					$secretRepeatInput = $identityEncryptView.find('#skIdS_identity-encrypt-repeat-input'),
                                        $inputError = _view.find('#skIdS_identity-encrypt-input-error');

				if (code === 13) { // RETURN key
                                    if ($secretInput.val().length >= _minSecretLength
                                                    && $secretRepeatInput.val().length >= _minSecretLength) {
                                        if (checkFields()) {
                                            Util.callCallbacks(encryptCallbacks, jQuery(this).val());
                                        } else {
                                            $secretInput.focus();
                                        }
                                    } else if ($secretInput.val().length >= _minSecretLength
                                                    && $secretRepeatInput.val().length < _minSecretLength) {
                                        $secretRepeatInput.focus();
                                    } else {
                                        $inputError.empty()
                                            .append(Strings.min_secret_length.replace('%%', _minSecretLength))
                                            .show();
                                        $secretInput.focus();
                                    }
				}
			}

			$identityEncryptView.find('#skIdS_identity-encrypt-first-input')
				.on('input', handleInput)
				.on('keypress', handleKeyPress);

			$identityEncryptView.find('#skIdS_identity-encrypt-repeat-input')
				.on('input', handleInput)
				.on('keypress', handleKeyPress);

			$identityEncryptView.find('#skIdS_identity-encrypt-input-error').hide();
			$identityEncryptView.find('#skIdS_identity-encrypt-fido-container').hide();
			
			$identityEncryptView.find('#skIdS_identity-encrypt-fido-input')
					.change(function() {
						if($identityEncryptView.find('#skIdS_identity-encrypt-fido-input').is(':checked')) {
							$identityEncryptView.find('#skIdS_identity-encrypt-fido-container').show();
							if (typeof input_callback === 'function') input_callback(true);
						} else {
							$identityEncryptView.find('#skIdS_identity-encrypt-fido-container').hide();
							if (typeof input_callback === 'function') input_callback(false);
						}
			});

			return $identityEncryptView;
		})();

		function checkFields() {
				var $secretInput = _view.find('#skIdS_identity-encrypt-first-input'),
					$secretRepeatInput = _view.find('#skIdS_identity-encrypt-repeat-input'),
					$inputError = _view.find('#skIdS_identity-encrypt-input-error');

				if ($secretInput.val() !== $secretRepeatInput.val()) {
					$inputError.empty()
						.append(Strings.error_match_text)
						.show();

					$secretInput.val('');
					$secretRepeatInput.val('');

					return false;
				}

				return true;
			}

		// public methods
		
		this.checkInput = function () {
			var secret = _view.find('#skIdS_identity-encrypt-first-input').val(),
                            secretRepeat = _view.find('#skIdS_identity-encrypt-repeat-input').val(),
                            $inputError = _view.find('#skIdS_identity-encrypt-input-error');

			if (secret.length >= _minSecretLength && secretRepeat.length >= _minSecretLength) {
				return true && checkFields();
			} else {
                            $inputError.empty()
                                .append(Strings.min_secret_length.replace('%%', _minSecretLength))
                                .show();
                            return false;
			}
			return false;
		};
		
		this.getInput = function () {
			return _view.find('#skIdS_identity-encrypt-first-input').val();
		};

		this.get = function () {
			return _view;
		};

		this.update = function () {
			_view.find('#skIdS_identity-encrypt-first-input').val('');
			_view.find('#skIdS_identity-encrypt-repeat-input').val('');
			_view.find('#skIdS_identity-encrypt-button').tooltip('enable');
			_view.find('#skIdS_identity-encrypt-input-error').empty().hide();
			_view.find('#skIdS_identity-encrypt-fido-input').prop( "checked", false );
			_view.find('#skIdS_identity-encrypt-fido-container').hide();
		};
		
		this.disableFIDO = function () {
			_view.find('#skIdS_identity-encrypt-fido-input-container').hide();
		};

		this.showError = function (error) {
			var $inputError = _view.find('#skIdS_identity-encrypt-input-error');

			$inputError.empty()
				.append(error)
				.show();
		};
		
		this.isChecked = function () {
			return _view.find('#skIdS_identity-encrypt-fido-input').is(':checked');
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/bindings/BindingView.js
// module id = 362
// module chunks = 1